import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly10A2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10A/8.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
    { src: p8, source: p8, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                  AYURVEDA - A NATURE’S WAY OF WELLNESS
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 10A   Date: 9 & 10 June 2026
                </Typography>

                <br />
               <Typography variant={'subtitle1'} align={'justify'}>
  The students of Class 10 A presented their class assembly on the theme
  <strong> “Ayurveda – A Nature’s Way of Wellness.”</strong> Through an engaging
  skit, the assembly explored the origins and evolution of Ayurveda, one of the
  world's oldest systems of health and well-being.
  <br></br>
  The performance began with a modern-day boy whose curiosity about recurring
  illness led him to discover the rich history of Ayurveda. The skit then
  travelled back in time to depict the legendary account of Sage Bharadwaja
  seeking divine knowledge from Lord Indra for the welfare of humanity. It
  further highlighted the invaluable contributions of Charaka, who organised
  Ayurvedic knowledge into a systematic medical science, and Sushruta, whose
  pioneering work in surgery and anatomy earned him lasting recognition.
  <br></br>
  The presentation emphasised Ayurveda's holistic approach to health, focusing
  on balance, prevention, healthy living and harmony with nature. Students
  reinforced the importance of ‘India’s Ancient Wisdom’ that
  has been forgotten by the present generation.
  <br></br>
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                &ldquo;Avurveda – The Science of Life.&rdquo;
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10A 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly10A2026;
